<template>
    <div>
        <el-page-header @back="close" :content="form.id > 0 ? '编辑黑名单' : '新增黑名单'"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="100px">
                    <el-form-item label="手机号" prop="mobile" :error="errors.mobile">
                        <el-input v-model="form.mobile" :show-word-limit="true" :maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="级别" prop="level.value" :error="errors.level" v-if="$root.isAdmin">
                        <RemoteSelect v-model="form.level.value" :url="'/dict/list/public/level'" @change="changeLevel"></RemoteSelect>
                    </el-form-item>
                    <el-form-item label="业务" prop="code" :error="errors.code" v-if="$root.isAdmin">
                      <Cascade v-model="form.code"></Cascade>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark" :error="errors.remark">
                        <el-input v-model="form.remark"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import RemoteSelect from '@/components/RemoteSelect'
    import Cascade from '@/components/Cascade'

    export default {
        components: {
          RemoteSelect,
          Cascade,
        },
        data() {
            return {
                form: {
                    id: this.$route.params.id,
                    mobile: "",
                    level: {value: 'customer'},
                    channelType: {},
                    remark: "",
                    code: this.$root.isAdmin ? "" : this.$root.code
                },
                rules: {
                    mobile: [
                        {required: true, message: "请填写手机号码"},
                        {min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur'}
                    ],
                    "level.value": [
                        {required: true, message: "请选择级别"}
                    ],
                },
                errors: {}
            }
        },
        beforeMount() {
            if (this.form.id > 0) {
                this.$axios.get("/blacklist/get/" + this.form.id).then(result => {
                    this.$utils.merge(this.form, result);
                })
            }
        },
        methods: {
            submit() {
                let url = this.form.id > 0 ? "/blacklist/edit" : "/blacklist/save";
                this.$utils.submit(this.$refs.form, url, this.form, () => {
                    this.$router.go(-1);
                }, (data) => {
                    this.errors = data;
                });
            },
            close() {
                this.$router.go(-1);
            },
            changeLevel(val) {
                if (val === "global") {
                    this.form.code = "";
                }
            }
        }
    }
</script>